/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import React from 'react';
import PageContextProvider from '@/context/PageContext';
import 'svgxuse';
import { sourcePromoCodeHandler } from './src/utils/sourcePromoCodeHandler';
export const onClientEntry = async () => {
  // need to import a polyfill for Intersection Observer to be used in IE11
  if (typeof IntersectionObserver === `undefined`) {
    await import(`intersection-observer`);
  }
  // to support URL api in IE11
  if (typeof URL !== 'function') {
    await import('url-polyfill');
  }
};

const passQueryParamsToLoansPortal = (link) => {
  const currentURL = new URL(window.location.href);
  const destinationURL = new URL(link.href);

  // Pass all query params from the current page URL
  currentURL.searchParams.forEach((value, key) => {
    destinationURL.searchParams.set(key, value);
  });

  window.open(destinationURL.toString(), "_blank");
};

export const onRouteUpdate = () => {
  // Replace this with your specific external URL or a pattern
  const targetExternalURL = "https://cards.latitudefinancial.com/";

  const links = document.querySelectorAll(`a[href^='${targetExternalURL}']`);

  links.forEach((link) => {
    // Attach click handler
    link.addEventListener("click", (e) => {
      e.preventDefault(); // prevent default navigation

      // Modify URL using your handler
      const newURL = sourcePromoCodeHandler(link.href);

      // Open in new tab (or same tab if you prefer)
      window.open(newURL, "_blank");
    });
  });

  // Loans portal logic
  const targetLoansPortalURL =
    "https://loans.portal.latitudefinancial.com.au/s/quote";

  const loanLinks = document.querySelectorAll(
    `a[href^='${targetLoansPortalURL}']`
  );

  loanLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      passQueryParamsToLoansPortal(link);
    });
  });
};

export const wrapRootElement = ({ element }) => (
  <PageContextProvider>{element}</PageContextProvider>
)
